import { Box, Grid, Typography, useTheme } from '@material-ui/core'
import { ErrorIcon } from '../../icons'
import * as React from 'react'

interface Props {
  title?: string
  variant?: 'info' | 'warn'
}

export function ContentBlock({
  title,
  children,
  variant = 'info',
}: React.PropsWithChildren<Props>) {
  const theme = useTheme()

  return (
    <>
      {title ? (
        <Box mb={1}>
          <Grid container alignItems="center" direction="row">
            {variant === 'warn' && (
              <ErrorIcon
                height={27}
                style={{ marginRight: theme.spacing(1) }}
                width={27}
              />
            )}
            <Typography
              style={{ fontWeight: theme.typography.fontWeightRegular }}
              variant="h6"
            >
              {title}
            </Typography>
          </Grid>
        </Box>
      ) : null}

      <Typography component="div" variant="body2">
        {children}
      </Typography>
    </>
  )
}
